export class HudApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAgencies(params) {
    return this.#http.get('/hud/agencies', { params });
  }
}
